import { useState, useEffect, useRef, useCallback } from "react";

export const useOnlineStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);
  const prevOnline = useRef(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      if (!prevOnline.current) {
        setWasOffline(true);
      }
      prevOnline.current = true;
      setIsOnline(true);
    };

    const handleOffline = () => {
      prevOnline.current = false;
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const clearWasOffline = useCallback(() => setWasOffline(false), []);

  return { isOnline, wasOffline, clearWasOffline };
};
